module.exports = __webpack_public_path__ + "img/loader-crumb2.792a7efb.svg";